<template>
  <div style="overflow-x: hidden">
    <Navbar />
    <Homes />
    <Swiper />
    <PostsBooths />
    <bottommenu />
  </div>
</template>
<script>
import Navbar from "@/layouts/navbar";
import Swiper from "@/components/sliders/swiper";
import Homes from "@/components/home/home.vue";
import PostsBooths from "@/components/home/postsbooths.vue";
import bottommenu from "@/menuApp.vue";

export default {
  name: "Home",

  components: { Navbar, Swiper, Homes, PostsBooths, bottommenu },
  metaInfo() {
    return {
      title: "نامیا",
      titleTemplate: "%s | اولین نمایشگاه مجازی کسب و کارها",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.app/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content: "https://namya.app/logo.jpg",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content: "https://namya.app/logo.jpg",
      },
    ],
  },
};
</script>
